import { render, staticRenderFns } from "./filter-by-beauty-profile.vue?vue&type=template&id=163c7e35&scoped=true"
import script from "./filter-by-beauty-profile.vue?vue&type=script&lang=js"
export * from "./filter-by-beauty-profile.vue?vue&type=script&lang=js"
import style0 from "./filter-by-beauty-profile.vue?vue&type=style&index=0&id=163c7e35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163c7e35",
  null
  
)

export default component.exports